var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "leaf [#15]"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-180.000000, -8119.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.231,7973 C135.469,7973 133.335,7972.944 131.549,7972.865 L135.121,7969.294 L138.021,7970.526 C138.369,7970.673 138.772,7970.595 139.039,7970.328 C139.504,7969.863 139.351,7969.076 138.746,7968.819 L136.535,7967.879 L139.316,7965.098 C139.707,7964.707 139.707,7964.074 139.316,7963.684 C138.926,7963.293 138.293,7963.293 137.902,7963.684 L136.578,7965.008 L135.806,7963.686 C135.487,7963.139 134.736,7963.042 134.287,7963.49 C133.977,7963.801 133.914,7964.282 134.136,7964.662 L135.164,7966.422 L130.137,7971.449 C130.056,7969.658 130,7967.53 130,7966.769 C130,7963.208 131.3,7961 137.769,7961 C138.617,7961 140.536,7961.079 141.846,7961.18 C141.934,7962.193 142,7963.513 142,7964.231 C142,7973 137.809,7973 136.231,7973 M143.609,7959.391 C142.703,7959.143 138.754,7959 137.769,7959 C131.822,7959 128,7960.822 128,7966.769 C128,7967.533 128.087,7971.278 128.241,7973.345 L124.293,7977.293 C123.902,7977.683 123.902,7978.317 124.293,7978.707 C124.684,7979.098 125.317,7979.098 125.707,7978.707 L129.655,7974.759 C131.722,7974.913 135.467,7975 136.231,7975 C142.179,7975 144,7970.178 144,7964.231 C144,7963.246 143.856,7960.297 143.609,7959.391",
    id: "leaf-[#15]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.18ba75c7d0e6f95029a5fa493f2aa222.svg";
export { ForwardRef as ReactComponent };